export function filterMap<M extends Map<any, any>>(map: M, predictor) {
  const filteredEntries = [...map.entries()].filter(predictor);

  return new Map(filteredEntries);
}
